import styled from 'styled-components'

import { TextStyled, type IBaseTextProps } from '@ui/elements/Text'

const MAX_DIGIT_WIDTH_PX = 10
const MIN_DIGITS = 2

interface IQuantityValueStyledProps extends IBaseTextProps {
  numDigits: number
}

export const QuantityValueStyled = styled(
  TextStyled
)<IQuantityValueStyledProps>`
  color: ${(props) => props.theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  text-align: center;

  min-width: ${({ theme, numDigits }) =>
    theme.typography.pxToRem(
      Math.max(numDigits, MIN_DIGITS) * MAX_DIGIT_WIDTH_PX
    )};
`
